export default __webpack_public_path__ + "static/media/Settings_Active.8951c0f6.svg";